import { render, staticRenderFns } from "./BannerArticle.vue?vue&type=template&id=2114f0c0&"
import script from "./BannerArticle.vue?vue&type=script&lang=js&"
export * from "./BannerArticle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports